import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    link: {
        color: 'black',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    endDateDatePickerAdornment: {
        display: 'none !important',
    },
    zipAutocomplete: {
        '& .MuiAutocomplete-endAdornment': {
            display: 'none',
        },
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important'
        }
    },
    hideOption: {
        pointerEvents: 'none',
        height: 0,
        padding: '0 !important',
    }
}))

export default useStyles
